import { useMutation } from "@tanstack/react-query";
import { triggerNotification } from "components/TheComponents/Notification";
import { useAppContext } from "contexts";
import { ExceptionHandlingType } from "types/apiServiceTypes";

export const DISCORD_VERIFY_QUERY_KEY = "user/id:/verify-discord";

export function useDiscordVerify() {
  const { apiService } = useAppContext();

  return useMutation({
    mutationFn: async (userId: string) => {
      try {
        const response = await apiService.get<{ result: boolean }>(
          `/user/${userId}/verify-discord`,
          {
            exceptionHandlingType: ExceptionHandlingType.MANUAL,
          }
        );
        if (response.result) {
          triggerNotification({ text: "Discord verified", type: "success" });
        } else {
          triggerNotification({ text: "Discord was not verified.", type: "warning" });
        }
      } catch (error: unknown) {
        let message = "Something went wrong during discord verification.";
        if (error instanceof Error) {
          message = error.message;
        }
        triggerNotification({ text: message, type: "error" });
      }
    },
    retry: false,
  });
}
